var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3435 6.58874L8.95787 13.0195L1.47787 8.41642C1.32803 8.32618 1.19765 8.20707 1.09425 8.06599C0.990847 7.92491 0.916487 7.7647 0.875548 7.59465C0.834608 7.42459 0.827851 7.24805 0.855716 7.07537C0.883581 6.90269 0.945499 6.73728 1.03785 6.58874C1.21728 6.30964 1.48867 6.10208 1.80502 6.00205L19.4615 0.947712C19.6289 0.899614 19.8042 0.885128 19.9772 0.905087C20.1503 0.925047 20.3176 0.979067 20.4697 1.06402C20.6218 1.14897 20.7555 1.26317 20.8632 1.40005C20.971 1.53694 21.0505 1.69378 21.0974 1.86156C21.1652 2.10513 21.1652 2.36257 21.0974 2.60614L15.8512 20.2513C15.8032 20.418 15.7228 20.5737 15.6145 20.7093C15.5063 20.845 15.3724 20.958 15.2204 21.0418C15.0685 21.1256 14.9015 21.1787 14.729 21.1979C14.5566 21.2171 14.382 21.2021 14.2153 21.1538C13.9003 21.0568 13.6316 20.8483 13.4594 20.5672L8.94658 13.1098",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSend);
export default __webpack_public_path__ + "static/media/darkSend.e5d0f5022d9891c59f8b6569d919d1ca.svg";
export { ForwardRef as ReactComponent };